export default {
    props: {
        model: {
            twoWay: true,
            default: null,
            required: true
        },
        label: {
            type: String,
            default: null
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        hint: {
            default: null
        },
        onChanged: {
            default: null
        },
        disabled: {
            default: false,
            type: Boolean
        },
        autofocus: {
            default: false,
            type: Boolean
        },
        name: {
            default: null,
            type: String
        }
    },
    data () {
        return {
            fieldName: null
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        this.inputClass = ['form-control']
    },
    methods: {
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        hasAppend () {
            return this.$hasSlot('append')
        },
        holderClass () {
            return {
                'input-icon': !!this.iconClass
            }
        },
        inputHolderClass () {
            return {
                'input-icon': !!this.iconClass,
                'input-group': this.hasAppend()
            }
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/components/std/generic/input.js